module.exports = __webpack_public_path__ + "static/media/success.f7fe640e.m4a";